import { endOfWeek as endOfWeekBase } from 'date-fns'
import { getLocale } from './getLocale'

export function endOfWeek(date: Date) {
  return endOfWeekBase(date, { locale: getLocale(), weekStartsOn: 1 })
}
